<template>
  <section class="all-cases-view">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row gutter="20">
            <el-col :lg="14" :xl="14">
              <ul class="d-flex list-items-group-15 barcode-print">
                <li>
                  <div
                    class="form-element input-with-icon search-input-lg w-200"
                  >
                    <el-input
                      ref="orderInput"
                      placeholder="Accession / Patient Name"
                      v-model="search_string"
                      @input="getAutoCompleteCases()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
                <li>
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      ref="barcodeInput"
                      placeholder="SCAN QR CODE"
                      v-model="barcodeNumber"
                      @input="getOrderDetails()"
                      :clearable="true"
                      @focus="handleFocus"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :lg="10" :xl="10">
              <ul class="d-flex justify-content-end list-items-group-15 w-90">
                <li v-if="searchBy === 'Priority' && this.priority">
                <div class="search-with-date-input">
                  <el-date-picker v-model="StartDate" type="date" placeholder="From Date" format="MM-DD-YYYY"  :clearable="true"
                    :disabled-date="date => date > new Date()"
                    @change="EndDate && handleCurrentChange(1)" value-format="YYYY-MM-DD" style="width: 100%;" />
                </div>
              </li>
              <li v-if="searchBy === 'Priority' && this.priority">
                <div class="search-with-date-input">
                  <el-date-picker v-model="EndDate" type="date" placeholder="To Date" format="MM-DD-YYYY" :clearable="true"
                    value-format="YYYY-MM-DD" :disabled-date="date => date > new Date()" style="width: 100%;" @change="handleCurrentChange(1)" />
                </div>
              </li>
 
                <li>
                  <div
                    class="form-element search-with-filter-input-without-icon"
                      :class="{ 'priority-mode': searchBy === 'Priority' }"
                  >  
                    <el-select
                      v-model="searchBy"
                      clearable
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      placeholder="Select Search"
                      @change="clearInputSearch"
                      @clear="clearSearchBy"
                      @focus="initializeSearchOptions"
                    >
                      <el-option
                        v-for="item in searchOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </div>
                </li>

                <li v-if="searchBy == 'hospital'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="hospital"
                      placeholder="Select Ordering Facility"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      @change="handleCurrentChange(1)"
                      remote
                      :remote-method="remoteMethodFacility"
                      :loading="hospitalLoading"
                    >
                      <el-option
                        v-for="hospital in hospitalsData.data"
                        :key="hospital"
                        :label="hospital.name"
                        :value="hospital.name"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'ordering_physician'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="physician"
                      placeholder="Select"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      @change="handleCurrentChange(1)"
                      :loading="physicianLoading"
                      remote
                      :remote-method="remoteMethodPhysician"
                    >
                      <el-option
                        v-for="physician in physiciansData.data"
                        :key="physician"
                        :label="physician.name"
                        :value="physician.name"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'case_types'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="caseType"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      @clear="clearTest"
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="caseType in getLabBasedCaseTypes(caseTypes)"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'Patient DOB'">
                  <div class="search-with-date-input">
                    <el-date-picker
                      format="MM-DD-YYYY"
                      v-model="date_of_birth"
                      :disabled-date="disabledDate"
                      @change="fetchAllPhlebioOrders()"
                      placeholder="Select DOB"
                      :clearable="true"
                    ></el-date-picker>
                  </div>
                </li>
                <li v-else-if="searchBy == 'Priority'">
                  <div class="form-element search-with-filter-input" 
                    :class="{ 'priority-selected': priority }"
                  >
                    <el-select          
                      v-model="priority"
                      placeholder="Select Priority"
                      filterable 
                      clearable
                      default-first-option
                      @clear="clearTest"
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                      :title="status.name"
                        v-for="status in priorityTypes"
                        :key="status"
                        :label="status.name"
                        :value="status.value"
                        class="truncate-option"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'Status'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="status"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      @clear="clearTest"
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="status in statusTypes"
                        :key="status"
                        :label="status.name"
                        :value="status.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="listings-navbar">
        <el-row gutter="20">
          <el-col :lg="12" :xl="12"> </el-col>
        </el-row>
      </div>
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllPhlebioOrders.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
          >
            <el-table-column label="Phlebio Order Id" width="160" fixed="left">
              <template #default="scope">
                <div class="name-accession" v-if="scope.row.Phlebio_Order_id">
                  <span
                    id="accession-id"
                    @click="viewPhlebioOrder(scope.row._id)"
                  >
                    {{ scope.row.Phlebio_Order_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Order Type" width="120" fixed="left">
              <template #default="scope">
                <div v-if="scope.row.Order_Type">
                  <span style="text-transform: uppercase;cursor: default;"
                  >
                    {{ scope.row.Order_Type }}
                  </span>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>            
            <el-table-column label="Priority" width="100" fixed="left">
              <template #default="scope">
                <div v-if="scope.row.Priority">
    <span
      :class="getPriorityClass(scope.row)"
      style="text-transform: uppercase; cursor: default;"
    >
      {{ scope.row.Priority }}
    </span>
  </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              prop="case_types"
              min-width="125px"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div
                  v-else-if="
                    scope.row.case_types && scope.row.case_types.length == 1
                  "
                  class="case-type"
                >
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>

            <el-table-column
              label="Patient Name"
              width="170"
              sortable="custom"
              prop="Patient_first_name"
              fixed="left"
            >
              <template #default="scope">
                <div class="name-accession" v-if="scope.row.patient_info" >
                  <span class="text-center ordering_facility-value" style="cursor: default;" >
                    {{ convertToUppercase(getPatientNameByInfo(scope.row.patient_info)) }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Patient DOB"
              min-width="120"
              sortable="custom"
              prop="Patient_dob"
            >
              <template #default="scope">
                <div style="cursor: default;">
                {{ formatDate(scope.row.Patient_dob) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Ordering Facilities"
              width="170"
              sortable="custom"
              prop="Client_name"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.Client_name ? scope.row.Client_name : '--'"
                >
                  <span
                    class="text-center ordering_facility-value"
                    v-if="scope.row.Client_name"
                    >{{ scope.row.Client_name }}</span
                  >
                  <span v-else>--</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Physician"
              min-width="120"
              sortable="custom"
              prop="Provider_first_name"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    (scope.row.Provider_first_name || '--') +
                    ' ' +
                    (scope.row.Provider_middle_name || '') +
                    ' ' +
                    (scope.row.Provider_last_name || '')
                  "
                >
                  <span class="ordering_physician-value">
                    {{
                      (scope.row.Provider_first_name || "--") +
                      " " +
                      (scope.row.Provider_middle_name || "") +
                      " " +
                      (scope.row.Provider_last_name || "")
                    }}
                  </span>
                </el-button>
              </template>
            </el-table-column>

            <el-table-column
              label="Created ON"
              width="125"
              sortable="custom"
              prop="created_at"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div style="cursor: default;" class="date pr-10">
                    {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Collected ON"
              width="125"
              prop="created_at"
            >
              <template #default="scope">
                <div
                  v-if="scope.row.Phlebio_Order_Status_History?.[0]"
                  class="d-flex"
                >
                  <div style="cursor: default;" class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.Phlebio_Order_Status_History[0]["Date/Time"],
                        "MM-DD-YYYY"
                      ) || "--"
                    }}
                  </div>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              width="150"
              prop="Status"
              sortable="custom"
            >
              <template #default="scope">
                <div class="column-status">
                  <span v-if="scope.row.Status" class="el-dropdown-link">
                    <el-tag
                    style="cursor: default;"
                      class="el-tag--phlebio"
                      :type="getStatusType(scope.row.Status)"
                      >{{ scope.row.Status }}
                    </el-tag>
                  </span>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Order/EMR" width="180">
              <template #default="scope">
                <div
                  class="name-accession cursor"
                  v-if="scope.row && scope.row.labsquire_order"
                >
                  <span
                    id="accession-id-blue"
                    @click="goToOrderView(scope.row.labsquire_order)"
                  >
                    {{ scope.row.labsquire_order ? scope.row.labsquire_order.order_id : "--" }}
                  </span>
                </div>
                <div
                  class="name-accession cursor"
                  v-if="scope.row && scope.row.emr_details"
                >
                  <span
                    id="accession-id-blue"
                    @click="viewEMR(scope.row.emr_details)"
                  >
                    {{ scope.row.emr_details ? scope.row.emr_details.emr_ref_id : "--"}}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="accession_id"
              label="ACCESSION ID"
              width="285"
            >
              <template #default="scope">
                <div
                  class="name-accession cursor"
                  v-if="
                    scope.row.accession_data && scope.row.accession_data.length
                  "
                >
                  <span
                    id="accession-id-blue"
                    class="order-accession"
                    v-for="(acccession, index) in scope.row.accession_data"
                    :key="index"
                    @click="goToCaseView(acccession.case_id)"
                  >
                    {{ acccession.accession_id }}
                  </span>
                </div>
                <div
                  class="name-accession cursor"
                  @click="goToCaseView(scope.row.case_id)"
                  v-else-if="scope.row.accession_id"
                >
                  <span id="accession-id-blue" class="order-accession">
                    {{ scope.row.accession_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              width="100"
              fixed="right"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li @click="viewPhlebioOrder(scope.row._id)">
                    <el-button class="view-button" title="View Phlebio">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="getAllPhlebioOrders.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseConstants from "@/config/constants/caseConstants";
import { phlebioSearchOptions } from "@/config/constants/searchConstants";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import caseDataHelper from "@/mixins/caseDataHelper";
import FilterHelper from "@/mixins/FilterHelper";
import moment from "moment";

export default {
  mixins: [UserPermissionsHelper, caseDataHelper, FilterHelper],
  data() {
    return {
      page: 1,
      pageSize: 25,
      StartDate: "",
      EndDate : "",
      loading: false,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      search_string: "",
      searchBy: "",
      hospitalsData: {},
      physiciansData: {},
      hospitalLoading: false,
      physicianLoading: false,
      searchOptions: phlebioSearchOptions,
      hospital: "",
      physician: "",
      caseTypes: caseConstants.CASE_TYPES_DATA,
      caseType: "",
      date_of_birth: "",
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      orderBy: "",
      orderType: "",
      status: "",
      statusTypes: caseConstants.PHLEBIO_ORDER_STATUS,
      priority: "",
      priorityTypes : caseConstants.PHLEBIO_ORDER_PRIORITY_TYPES ,
      barcodeNumber: "",
    };
  },
  props: {
    isPhlebioOrders: {
      default: false,
    },
    isPhlebioRequests: {
      default: false,
    },
    isPhlebioLabsquireOrders:{
      default: false, 
    }
  },
  computed: {
    ...mapGetters("phlebio", [
      "getAllPhlebioOrders",
      "getCaseConversionStatus",
      "getCaseData",
      "getScanOrderDetails",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "";
        } else if (status == "CREATED") {
          return "success";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "pending") {
          return "danger";
        } else {
          return "";
        }
      };
    },
  },
  async mounted() {
    this.$nextTick(() => {
      if (this.hasPermission("cases", "create_case")) {
        this.setDefaultFocus(); // Set initial focus to barcodeInput
        document.addEventListener("click", this.focusInput.bind(this));
      }
    });
    this.setQueryParamsData();

    await this.fetchAllPhlebioOrders();
  },
  methods: {
    
    viewEMR(orderId) {
      this.$router.push({
        name: "View-Case-Information",
        params: { order_id: orderId._id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },

    getPriorityClass(row) {
      if (row.Priority === "STAT") {
        switch (row.stat_indication) {
          case "red blink":
            return "red-blink";
          case "orange blink":
            return "orange-blink";
          case "normal":
          default:
            return "normal-priority";
        }
      }
      return "";
    },
  
    goToOrderView(order_id) {
      this.$router.push({
        name: "Order-Information",
        params: { order_id: order_id._id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async remoteMethodFacility(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryFacility", query);
        await this.fetchAllHospitals(query);
      }
    },
    setDefaultFocus() {
      this.$nextTick(() => {
        if (this.$refs.barcodeInput) {
          this.$refs.barcodeInput.focus();
        }
      });
    },
    handleFocus() {
      this.$refs.barcodeInput.focus();
    },
    focusInput(event) {
      // Check if the click is inside any of the input fields
      const isOrderInputClicked =
        this.$refs.orderInput &&
        this.$refs.orderInput.$el &&
        this.$refs.orderInput.$el.contains(event.target);
      const isBarcodeInputClicked =
        this.$refs.barcodeInput &&
        this.$refs.barcodeInput.$el &&
        this.$refs.barcodeInput.$el.contains(event.target);

      // Handle focus based on the input field clicked
      if (isOrderInputClicked && this.$refs.orderInput) {
        this.$refs.orderInput.focus();
      } else if (!isBarcodeInputClicked && this.$refs.barcodeInput) {
        this.$refs.barcodeInput.focus();
      }
    },
    canShowEditButton() {
      const order = this.getScanOrderDetails;

      if (!order) return false;

      // Check for valid statuses
      const validStatuses = [
        "Completed",
        "Performed",
        "Delivered to Lab",
        "Accession created",
        "Deliverd to Lab",
        "Partial Accession"
      ];

      // Check if status is valid
      const isStatusValid = validStatuses.includes(order.Status);

      // Check if accession_id exists
      const isAccessionCreated = !!order.accession_id;

      // Check if accession_data and case_types lengths are the same
      const isLengthsEqual =
        order.accession_data?.length === order.case_types?.length;

      return isStatusValid && !isAccessionCreated && !isLengthsEqual;
    },
    async getOrderDetails() {
      try {
        let updateBarcode = this.barcodeNumber.trim();
        let params = {
          phlebioOrderId: updateBarcode.toLocaleUpperCase(),
        };
        await this.$store.dispatch("phlebio/fetchScanOrderById", params);
        if (this.getScanOrderDetails) {
          if (this.canShowEditButton() && !this.getScanOrderDetails.Emr_order_id) {
            this.editPhlebioOrder(this.getScanOrderDetails._id);
          } else {
            this.viewPhlebioOrder(this.getScanOrderDetails._id);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }

      if (this.$route.query.selectedCase) {
        this.caseType = this.$route.query.selectedCase;
        this.fetchAllPhlebioOrders();
      }
      
      if (this.$route.query.selectedPhysician) {
        const savedQuery = localStorage.getItem("searchQueryPhysician");
        if (savedQuery && this.$route.query.selectedString !== savedQuery) {
          this.fetchAllPhysicians(savedQuery);
        }
        this.physician = this.$route.query.selectedPhysician;
      }
      if (this.$route.query.selectedHospital) {
        const savedQuery = localStorage.getItem("searchQueryFacility");
          if (savedQuery && this.$route.query.selectedString !== savedQuery) {
            this.fetchAllHospitals(savedQuery);
          }
        this.hospital = this.$route.query.selectedHospital;
      }
      if (this.$route.query.selectedDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedDateOfBirth;
      }
      if (this.$route.query.selectedOrderBy) {
        this.orderBy = this.$route.query.selectedOrderBy;
      }
      if (this.$route.query.selectedOrderType) {
        this.orderType = this.$route.query.selectedOrderType;
      }

      if (this.$route.query.selectedStatusType) {
        this.status = Array.isArray(this.$route.query.selectedStatusType)
          ? this.$route.query.selectedStatusType[0]
          : this.$route.query.selectedStatusType;
      }
      this.searchBy = this.$route.query.selectedSearchBy;

      if (this.$route.query.selectedPriorityType) {
        this.priority = this.$route.query.selectedPriorityType
      }
      if (this.$route.query.startDate) {
        this.StartDate = this.$route.query.startDate
      }
      if (this.$route.query.endDate) {
        this.EndDate = this.$route.query.endDate
      }
    },

    initializeSearchOptions() {
      this.searchOptions = [...this.searchOptions];
    },
    clearSearchBy() {
      this.fetchAllPhlebioOrders(1);
    },
    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.caseType ||
        this.search_string ||
        this.date_of_birth ||
        this.status || 
        this.priority || 
        this.StartDate ||
        this.EndDate 
      ) {
        this.hospital = "";
        this.physician = "";
        this.caseType = "";
        this.search_string = "";
        this.date_of_birth = "";
        this.page = 1;
        this.status = "";
        this.priority = "",
        this.StartDate = "",
        this.EndDate = ""
        this.fetchAllPhlebioOrders(1);
      }
    },

    async remoteMethodPhysician(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryPhysician", query);
        await this.fetchAllPhysicians(query);
      }
    },
    async fetchAllPhysicians(physician) {
      this.physicianLoading = true;
      let params = {
        limit: 25,
      };
      if (physician) {
        params.search_string = physician;
      }
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      this.physicianLoading = false;
    },
    async fetchAllHospitals(hospital) {
      this.hospitalLoading = true;
      let params = {
        limit: 25,
      };
      if (hospital) {
        params.search_string = hospital;
      }
      await this.$store.dispatch("hospitals/fetchAllHospitals", params);
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalLoading = false;
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    viewPhlebioOrder(phleboId) {
      this.$router.push({
        name: "PhlebioOrderDetails",
        params: {
          phlebio_id: phleboId,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    editPhlebioOrder(phleboId) {
      this.$router.push({
        name: "EditPhlebioOrderDetails",
        params: {
          phlebio_id: phleboId,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllPhlebioOrders();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllPhlebioOrders();
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
   
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.priority) {
        params.priority = "STAT"
      }
      if (this.priority ) {
        params.filterType = this.priority
      }
      if (this.StartDate) {
        params.StartDate = this.StartDate
      }
      if (this.EndDate) {
        params.EndDate = this.EndDate
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.hospital) {
        params.Client_name = this.hospital;
      }
      if (this.physician) {
        // Remove "Dr" from the physician name if it exists
        params.Provider_name = this.physician.replace(/^Dr\s+/, "");
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.Patient_dob = date_of_birth;
      }
      if (this.orderBy && this.orderType) {
        params.sort_by = this.orderBy;
        params.sort_type = this.orderType;
      }
      if (this.status) {
        params.status = Array.isArray(this.status)
          ? this.status
          : [this.status];
      }
      if(this.isGowthamUser){
        params.is_old = true
      }
      return params;
    },
    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllPhlebioOrders();
      }, 600);
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllPhlebioOrders();
    },
    async fetchAllPhlebioOrders() {
      try {
        this.loading = true;
        let params = this.prepareParams();

        await this.$store.dispatch("phlebio/fetchPhlebioOrders", params);
        this.updateQueryParams(params);

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedCase: params.case_type,
        selectedHospital: params.Client_name,
        selectedPhysician: params.Provider_name,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedSearchBy: this.searchBy || undefined,
        selectedDateOfBirth: params.Patient_dob,
        selectedOrderBy: params.sort_by,
        selectedOrderType: params.sort_type,
        selectedStatusType: params.status,
        selectedPriorityType: params.filterType,
        startDate: params.StartDate,
        endDate : params.EndDate
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async convertToCase(order) {
      this.loading = true;

      let params = {
        phlebio_id: order._id,
      };
      await this.$store.dispatch("phlebio/prepareCaseData", params);
      if (this.getCaseData) {
        this.$store.dispatch("phlebio/setPhlebioInfo", this.getCaseData.data);
        this.$router.push({
          name: "Create-Accession",
          params: { phlebio_id: order._id },

          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      } else {
        errorNotification(this.getError || "Unable to fetch order data");
      }
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.truncate-option {
  max-width: 200px; /* Adjust max-width as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

::v-deep(.priority-selected .el-select .el-input__inner) {
  font-size: 12px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.red-blink {
  color: red;
  font-weight: 600;
  animation: blink 2s infinite;
}

.orange-blink {
  color: orange;
  font-weight: 600;
  animation: blink 2s infinite;
}

.normal-priority {
  color: inherit;
  font-weight: normal;
}

/* Blink animation */
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}
</style>